export interface AdminEmailSearch {
  new?: boolean;
  edit?: string;
}

// Accepts the forms produced by TanStack's search parser when pasting a
// deep link: the boolean `true` (which we serialize ourselves), but also the
// NUMBER `1` (TanStack auto-parses `?new=1` → number 1, not a string) and the
// strings "1"/"true". Without the numeric case, `?new=1` pasted into the address bar
// evaluated to `undefined` → the router removed the parameter on boot and the
// "new template" overlay never opened (CC-18).
const asBool = (v: unknown): boolean | undefined =>
  v === true || v === 1 || v === "1" || v === "true" ? true : undefined;

/** URL-addressable search coercion for the email editor (#15b G8). */
export function parseAdminEmailSearch(raw: Record<string, unknown>): AdminEmailSearch {
  return {
    new: asBool(raw.new),
    edit: typeof raw.edit === "string" && raw.edit !== "" ? raw.edit : undefined,
  };
}
